export default "__VITE_ASSET__c575f2bb__"